// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/index.css'
import './assets/js/rem.js'
// import './assets/js/map'
import VueI18n from 'vue-i18n'
import VueSwiper from 'vue-awesome-swiper'
import { Popup, Swipe, SwipeItem } from 'mint-ui'
import ElementUI from 'element-ui';
import 'swiper/dist/css/swiper.css';
import 'element-ui/lib/theme-chalk/index.css';

import Element from 'element-ui';
Vue.use(Element, { size: 'small', zIndex: 3000 });

import { DatetimePicker } from 'vant';

Vue.use(DatetimePicker);
// import 'lib-flexible/flexible.js'
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.use(VueSwiper)
Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.component(Popup.name, Popup)
Vue.use(ElementUI);
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)
let bus = new Vue()
Vue.prototype.bus = bus
/* eslint-disable no-new */
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': require('./assets/js/zh'),
    'en': require('./assets/js/en')
  }
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  // document.documentElement.scrollTop = document.body.scrollTop = 0
})
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js